<template>
  <van-dialog
    v-model="isShow"
    class="dialog-box"
    :showConfirmButton="false"
    @closed="onClosed"
  >
    <div class="title">{{ title }}</div>
    <div class="sub-title">{{ subTitle }}</div>
    <div class="button-box">
      <div class="cancel button" @click="cancel" v-if="cancelText">
        {{ cancelText }}
      </div>
      <div class="submit button" @click="confirm" v-if="confirmText">
        {{ confirmText }}
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { Dialog } from 'vant';
export default {
  name: 'app-confirm',
  data() {
    return {
      isShow: true,
      title: '',
      subTitle: '',
      confirmText: '',
      cancelText: '',
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  methods: {
    show(cb) {
      typeof cb === 'function' && cb.call(this, this);
      return new Promise((resolve, reject) => {
        this.reject = reject;
        this.resolve = resolve;
      });
    },
    confirm() {
      this.resolve && this.resolve('confirm');
      this.hide();
    },
    cancel() {
      this.reject && this.reject('cancel');
      this.hide();
    },
    hide() {
      this.isShow = false;
    },
    onClosed() {
      this.$nextTick(() => {
        document.body.removeChild(this.$el);
        this.$destroy();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-box {
  background: #ffffff;
  border-radius: 10px;
  padding: 24px;
  width: 80%;
  text-align: center;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    color: #202020;
    margin-bottom: 12px;
    font-weight: bold;
  }
  .sub-title {
    font-size: 14px;
    color: #777777;
    line-height: 20px;
  }
  .button-box {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .button {
      border-radius: 2px;
      font-size: 16px;
      text-align: center;
      line-height: 44px;
      height: 44px;
      flex: 1;
      font-weight: bold;
    }
    .button + .button {
      margin-left: 6px;
    }
    .cancel {
      background: #e9e9e9;
      color: #505050;
    }
    .submit {
      background: #ffda05;
      color: #202020;
    }
  }
}
</style>